import http from "@/utils/http";

//获取列表
export async function getHome() {
    return http.get('/api/index/getHome', {})
}

/**
 * 获取文章列表
 * @param data
 * @param pageIndex
 * @param pageSize
 * @returns {Promise<unknown>}
 */
export async function getArticleList(data, pageIndex, pageSize) {
    return http.post('/api/article/getList?pageIndex=' + pageIndex + "&pageSize=" + pageSize, data)
}

/**
 * 获取文章信息
 * @param data
 * @returns {Promise<unknown>}
 */
export async function getArticleDetail(id) {
    return http.get('/api/Article/GetDetail?id=' + id, {})
}

/**
 * 获取手套分类首页
 * @returns {Promise<unknown>}
 */
export async function getGloveCategoryIndex() {
    return http.get('/api/gloveInfo/getIndex', {})
}

/**
 * 获取产品信息
 * @returns {Promise<unknown>}
 */
export async function getProductInfoIndex() {
    return http.get('/api/productInfo/getIndex', {})
}

/**
 * 获取
 * @returns {Promise<unknown>}
 */
export async function getAwardsIndex() {
    return http.get('/api/Awards/getIndex', {})
}

/**
 * 获取发展历史
 * @returns {Promise<unknown>}
 */
export async function getCourseInfoIndex() {
    return http.get('/api/CourseInfo/getIndex', {})
}

/**
 * 获取产品信息
 * @param id
 * @returns {Promise<unknown>}
 */
export async function getProductInfoDetail(id) {
    return http.get('/api/ProductInfo/GetDetail?id=' + id, {})
}

/**
 * 获取联系人
 * @returns {Promise<unknown>}
 */
export async function getContactusIndex() {
    return http.get('/api/Contactus/getIndex', {})
}

/**
 * 添加联系人
 * @returns {Promise<unknown>}
 */
export async function addContactus(data) {
    return http.post('/api/Contactus/add', data)
}

export async function getIndex() {
    return http.get('/api/Index/GetHome', {})
}

//获取列表
export async function getList(data, pageIndex, pageSize) {
    return http.post('/api/adv/getList?pageIndex=' + pageIndex + "&pageSize=" + pageSize, data)
}